<template>
  <div class="service-unavailable">
    <div class="card">
      <div class="icon"><v-icon size="30" color="#66c7b4">mdi-server-network-off</v-icon></div>

      <h1 class="code">503</h1>
      <h2 class="title">Service temporarily unavailable</h2>

      <p class="message">
        We’re having trouble reaching the server right now.
        Please try again in a moment.
      </p>

      <button class="duallo-btn duallo-btn--primary retry-btn" @click="retry">
        Try again
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceUnavailable",
  methods: {
    retry() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.service-unavailable {
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(120% 80% at 50% 0%, #20272e 0%, #141a1f 60%);
  color: var(--duallo-text-primary);
}

.card {
  max-width: 420px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: var(--duallo-card-gradient);
  border: 1px solid var(--duallo-border-strong);
  border-radius: var(--duallo-radius-xl);
  box-shadow: var(--duallo-shadow-lg);
  padding: 28px 24px 24px;
}

.icon {
  width: 56px;
  height: 56px;
  border-radius: var(--duallo-radius-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(102, 199, 180, 0.1);
  border: 1px solid var(--duallo-border-accent);
}

.code {
  font-size: 4rem;
  margin: 4px 0 0;
  font-weight: 800;
  letter-spacing: -2px;
  color: var(--duallo-text-primary);
  line-height: 1;
}

.title {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 800;
  color: var(--duallo-text-primary);
}

.message {
  color: var(--duallo-text-muted);
  font-size: 0.92rem;
  line-height: 1.55;
  margin: 0;
}

.retry-btn {
  margin-top: 8px;
}
</style>
